"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.dataList != null ? _c("template-table", {
    ref: "table",
    attrs: {
      loading: _vm.listloading,
      "table-data": _vm.dataList,
      "table-cols": _vm.columns,
      "page-meta": _vm.meta,
      "go-func": _vm.handlePageTurn,
      "change-size-func": _vm.handlePageSize,
      "operation-width": _vm.operationWidth,
      "row-key": "rowId",
      "search-bar-left": true,
      operations: _vm.operations,
      "search-bar-right": _vm.searchBarRightAll,
      "span-method": _vm.spanMethod,
      stripe: _vm.stripe,
      "support-selection": _vm.supportSelection,
      "handle-selection-change": _vm.handleSelectionChange,
      "show-pagination": _vm.showPagination,
      "show-search-button": _vm.showSearchButton,
      "operation-fixed": _vm.operationFixed,
      "operation-dropdown": _vm.operationDropdown,
      "sort-change": _vm.sortChange
    },
    on: {
      search: function ($event) {
        _vm.query.page = 1;
        _vm.loadList();
      }
    },
    scopedSlots: _vm._u([{
      key: "search",
      fn: function () {
        return [_c("div", {
          staticClass: "search-filters"
        }, [_c("div", {
          staticClass: "search-filters-row"
        }, [_c("div", {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: _vm.searchLoading,
            expression: "searchLoading"
          }],
          staticClass: "search-loading-container"
        }, _vm._l(_vm.filters, function (item) {
          return _c("span", {
            key: item.query,
            class: {
              "new-line": item.newLine
            }
          }, [item.remoteSearch != null ? _c("el-select", {
            attrs: {
              clearable: "",
              filterable: "",
              size: "small",
              remote: "",
              placeholder: _vm.$t(item.placeholder),
              "remote-method": query => {
                _vm.remoteSearch(query, item.remoteSearch, item.remoteSearchParam);
              }
            },
            on: {
              clear: () => {
                _vm.searchOptions[item.remoteSearch] = [];
                _vm.loadList();
              }
            },
            model: {
              value: _vm.query[item.query],
              callback: function ($$v) {
                _vm.$set(_vm.query, item.query, $$v);
              },
              expression: "query[item.query]"
            }
          }, _vm._l(_vm.searchOptions[item.remoteSearch], function (option) {
            return _c("el-option", {
              key: option.id,
              attrs: {
                label: option.name || option.title,
                value: option.id
              }
            });
          }), 1) : item.dateRange != null ? _c("el-date-picker", {
            attrs: {
              size: "small",
              clearable: false,
              type: item.type || "datetimerange",
              "range-separator": _vm.$t("common.select_to"),
              "start-placeholder": _vm.$t("common.start_time"),
              "end-placeholder": _vm.$t("common.end_time"),
              "value-format": "yyyy-MM-dd HH:mm:ss",
              "default-time": ["00:00:00", "23:59:59"],
              "picker-options": {
                shortcuts: [{
                  text: "最近一周",
                  onClick(picker) {
                    const end = new Date();
                    end.setHours(23, 59, 59, 999);
                    const start = new Date(end);
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", [start, end]);
                  }
                }, {
                  text: "最近一个月",
                  onClick(picker) {
                    const end = new Date();
                    end.setHours(23, 59, 59, 999);
                    const start = new Date(end);
                    start.setMonth(start.getMonth() - 1);
                    picker.$emit("pick", [start, end]);
                  }
                }, {
                  text: "最近三个月",
                  onClick(picker) {
                    const end = new Date();
                    end.setHours(23, 59, 59, 999);
                    const start = new Date(end);
                    start.setMonth(start.getMonth() - 3);
                    picker.$emit("pick", [start, end]);
                  }
                }],
                disabledDate(time) {
                  const threeMonthsAgo = new Date();
                  threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
                  return time.getTime() < threeMonthsAgo.getTime();
                }
              }
            },
            on: {
              change: function ($event) {
                return _vm.handleDateQueryChange(item.dateRange);
              }
            },
            model: {
              value: _vm.query.dateRange,
              callback: function ($$v) {
                _vm.$set(_vm.query, "dateRange", $$v);
              },
              expression: "query.dateRange"
            }
          }) : item.selection != null ? _c("el-select", {
            attrs: {
              placeholder: _vm.$t(item.placeholder),
              size: "small",
              clearable: ""
            },
            on: {
              clear: function ($event) {
                _vm.query[item.query] = null;
                _vm.loadList();
              }
            },
            model: {
              value: _vm.query[item.query],
              callback: function ($$v) {
                _vm.$set(_vm.query, item.query, $$v);
              },
              expression: "query[item.query]"
            }
          }, _vm._l(item.selection, function (s) {
            return _c("el-option", {
              key: s.value,
              attrs: {
                label: s.label,
                value: s.value
              }
            });
          }), 1) : _c("el-input", {
            attrs: {
              size: "small",
              clearable: "",
              placeholder: _vm.$t(item.placeholder)
            },
            on: {
              clear: _vm.loadList
            },
            model: {
              value: _vm.query[item.query],
              callback: function ($$v) {
                _vm.$set(_vm.query, item.query, $$v);
              },
              expression: "query[item.query]"
            }
          })], 1);
        }), 0)])])];
      },
      proxy: true
    }], null, false, 1768793244)
  }) : _vm._e(), _c("edit-dialog", {
    ref: "dialog",
    attrs: {
      "form-fields": _vm.fields,
      "form-rules": _vm.rules,
      endpoint: _vm.endpoint,
      width: _vm.dialogWidth,
      "can-confirm": _vm.canConfirm,
      object: _vm.editObject,
      "label-position": _vm.labelPosition,
      visible: _vm.editDialogVisible,
      title: _vm.editTitle != null ? _vm.editTitle : _vm.editObject === null || _vm.editObject.id === null ? _vm.$t("common.create") : _vm.$t("common.edit"),
      "format-request-data": _vm.formatRequestData,
      "after-handle-open": _vm.afterHandleOpen,
      "skip-form-validation": _vm.skipFormValidation,
      "update-endpoint": _vm.updateEndpoint,
      "dialog-custom-class": _vm.dialogCustomClass
    },
    on: {
      close: _vm.handleClose,
      confirm: function ($event) {
        _vm.$emit("confirm");
        _vm.loadList();
        _vm.searchOptions = {};
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (slotProp) {
        return [_vm._l(_vm.editableParams.filter(e => e.showInDialog != false && (e.hide == null || !e.hide())), function (item) {
          return _c("el-form-item", {
            key: item.key,
            class: item.formItemStyleClass,
            attrs: {
              "label-width": "100px",
              label: item.label != null ? _vm.$t(item.label) : _vm.$t(_vm.pageName + "." + item.key),
              prop: item.key
            }
          }, [item.remoteSearch != null ? _c("el-select", {
            attrs: {
              clearable: "",
              filterable: "",
              remote: "",
              placeholder: _vm.$t(item.label),
              "remote-method": query => {
                _vm.remoteSearch(query, item.remoteSearch, item.remoteSearchParam);
              },
              loading: slotProp.loading,
              disabled: item.disabled != null ? item.disabled() : false
            },
            model: {
              value: slotProp.form[item.key],
              callback: function ($$v) {
                _vm.$set(slotProp.form, item.key, $$v);
              },
              expression: "slotProp.form[item.key]"
            }
          }, _vm._l(_vm.searchOptions[item.remoteSearch], function (option) {
            return _c("el-option", {
              key: option.id,
              attrs: {
                label: option.name || option.title,
                value: item.optionKey != null ? option[item.optionKey] : option.id
              }
            });
          }), 1) : item.options != null ? _c("el-select", {
            attrs: {
              placeholder: _vm.$t(item.label),
              loading: slotProp.loading,
              disabled: item.disabled != null ? item.disabled() : false
            },
            model: {
              value: slotProp.form[item.key],
              callback: function ($$v) {
                _vm.$set(slotProp.form, item.key, $$v);
              },
              expression: "slotProp.form[item.key]"
            }
          }, _vm._l(item.options(), function (option) {
            return _c("el-option", {
              key: option.id,
              attrs: {
                label: option.name || option.title,
                value: item.optionKey != null ? option[item.optionKey] : option.id
              }
            });
          }), 1) : item.remoteAutoComplete != null ? _c("el-autocomplete", {
            attrs: {
              "fetch-suggestions": (query, cb) => {
                item.remoteAutoComplete(query, cb);
              },
              placeholder: _vm.$t(item.label),
              "trigger-on-focus": false,
              disabled: item.disabled != null ? item.disabled() : false,
              clearable: ""
            },
            model: {
              value: slotProp.form[item.key],
              callback: function ($$v) {
                _vm.$set(slotProp.form, item.key, $$v);
              },
              expression: "slotProp.form[item.key]"
            }
          }) : item.inputType == "cascader" ? _c("el-cascader", {
            attrs: {
              options: item.options
            },
            on: {
              change: function ($event) {
                return item.handleChange($event, slotProp.form);
              }
            },
            model: {
              value: slotProp.form[item.key],
              callback: function ($$v) {
                _vm.$set(slotProp.form, item.key, $$v);
              },
              expression: "slotProp.form[item.key]"
            }
          }) : item.inputType == "integer" ? _c("el-input-number", {
            model: {
              value: slotProp.form[item.key],
              callback: function ($$v) {
                _vm.$set(slotProp.form, item.key, $$v);
              },
              expression: "slotProp.form[item.key]"
            }
          }) : item.inputType == "region" ? _c("el-cascader", {
            attrs: {
              size: "large",
              options: _vm.options,
              clearable: "",
              disabled: item.disabled != null ? item.disabled() : false
            },
            on: {
              change: function ($event) {
                return item.handleChange($event, slotProp.form);
              }
            },
            model: {
              value: slotProp.form[item.key],
              callback: function ($$v) {
                _vm.$set(slotProp.form, item.key, $$v);
              },
              expression: "slotProp.form[item.key]"
            }
          }) : item.slot != null ? _vm._t(item.slot, null, {
            itemKey: item.key,
            form: slotProp.form,
            loading: slotProp.loading,
            disabled: slotProp.loading || (item.disabled != null ? item.disabled() : false),
            placeholder: _vm.$t("common.input_placeholder") + _vm.$t(_vm.pageName + "." + item.key)
          }) : _c("el-input", {
            attrs: {
              placeholder: _vm.$t("common.input_placeholder") + _vm.$t(_vm.pageName + "." + item.key),
              clearable: "",
              disabled: slotProp.loading || (item.disabled != null ? item.disabled() : false),
              type: item.inputType || "text"
            },
            model: {
              value: slotProp.form[item.key],
              callback: function ($$v) {
                _vm.$set(slotProp.form, item.key, $$v);
              },
              expression: "slotProp.form[item.key]"
            }
          })], 2);
        }), _vm._t("default", null, {
          form: slotProp.form,
          loading: slotProp.loading
        })];
      }
    }], null, true)
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;